const parsePosts = (posts) => {
    return posts.nodes
    .filter(post => post.content) // Filtrar solo posts con content no nulo
    .map(post => {
        const content = post.content.length < 200 ? `${post.content.slice(0, post.content.length - 5)}...` : `${post.content.slice(0, 200)}...`;
        return {
            title: post.title,
            content,
            mediaItemUrl: post.featuredImage?.node?.mediaItemUrl || null,
            slug: post.slug,
        };
    });
}

export default parsePosts